import React, {useContext} from "react";
import {Container} from "react-bootstrap";
import Menu from "../menu";
// @ts-ignore
import classes from "./index.module.css";
// @ts-ignore
import lightstoneLogo from "../../assets/images/Lightstone-Logo.jpg";
import ContactInfo from "../contact-info";
import authContext from "../../store/auth-context";
import LogoutWarning from "./logout-warning";

const Layout:React.FC<{children:React.ReactNode}> = (props) => {
    const authCtx = useContext(authContext);

    return <Container fluid className={[classes.background, "d-flex", "flex-column", "min-vh-100"].join(" ")}>
        <Menu />
        <Container>
            {props.children}
        </Container>
        <footer className="mt-auto d-flex align-items-end justify-content-between">
            <span />
            <ContactInfo />
            <img src={lightstoneLogo} alt="Lightstone Logo" />
        </footer>
        <LogoutWarning />
    </Container>;
}

export default Layout;